const esTranslation = {
  goToSenecaLearning: "Ir a Seneca Learning 📚",
  continueWithProvider: "Continuar con {{provider}}",
  redirectBackToTheApp: "Redirigir de nuevo a la aplicación",
};

export default esTranslation;
